export default __webpack_public_path__ + "static/image3-41c8c70349fe6a2ea54ccdc6e6e5f104.jpeg";